/* ============================================
   COOL MUMS CLUB — Main JS
   Version 1.0 · 2026
   ============================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* HEADER SCROLL BEHAVIOUR */
  const header = document.getElementById('site-header');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('scrolled', window.scrollY > 20);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* MOBILE NAV */
  const menuToggle = document.getElementById('menu-toggle');
  const mobileNav = document.getElementById('mobile-nav');
  const navOverlay = document.getElementById('nav-overlay');
  const navClose = document.getElementById('nav-close');

  function openNav() {
    mobileNav && mobileNav.classList.add('open');
    navOverlay && navOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeNav() {
    mobileNav && mobileNav.classList.remove('open');
    navOverlay && navOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  menuToggle && menuToggle.addEventListener('click', openNav);
  navClose && navClose.addEventListener('click', closeNav);
  navOverlay && navOverlay.addEventListener('click', closeNav);

  /* SCROLL REVEAL */
  const revealEls = document.querySelectorAll('[data-reveal]');
  if (revealEls.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry, i) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            entry.target.classList.add('revealed');
          }, i * 80);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    revealEls.forEach(el => observer.observe(el));
  } else {
    revealEls.forEach(el => el.classList.add('revealed'));
  }

  /* COLLECTION SORT */
  const sortSelect = document.getElementById('sort-by');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  /* PRODUCT OPTIONS */
  const optionBtns = document.querySelectorAll('.option-btn');
  const variantIdInput = document.getElementById('variant-id');

  if (optionBtns.length && variantIdInput) {
    const selectedOptions = {};

    optionBtns.forEach(btn => {
      btn.addEventListener('click', function () {
        const index = this.dataset.optionIndex;
        const value = this.dataset.value;

        document.querySelectorAll(`.option-btn[data-option-index="${index}"]`)
          .forEach(b => b.classList.remove('selected'));
        this.classList.add('selected');

        selectedOptions[index] = value;
        updateVariant(selectedOptions);
      });

      if (btn.classList.contains('selected')) {
        selectedOptions[btn.dataset.optionIndex] = btn.dataset.value;
      }
    });

    function updateVariant(selected) {
      if (typeof window.__productVariants === 'undefined') return;
      const variants = window.__productVariants;
      const selectedValues = Object.values(selected);

      const match = variants.find(v =>
        v.options.every((opt, i) => opt === selectedValues[i])
      );

      if (match) {
        variantIdInput.value = match.id;
        const priceEl = document.getElementById('product-price');
        if (priceEl) {
          priceEl.textContent = formatMoney(match.price);
        }
      }
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
    }
  }

  /* PRODUCT IMAGE SWAP (for future gallery thumbnails) */
  document.querySelectorAll('.product-thumb').forEach(thumb => {
    thumb.addEventListener('click', function () {
      const mainImg = document.getElementById('product-main-image');
      if (mainImg && this.dataset.src) {
        mainImg.src = this.dataset.src;
      }
    });
  });

});

  /* BACK TO TOP */
  var backToTop = document.getElementById('back-to-top');
  if (backToTop) {
    window.addEventListener('scroll', function () {
      backToTop.classList.toggle('visible', window.scrollY > 400);
    }, { passive: true });
    backToTop.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* COOKIE BANNER */
  var cookieBanner = document.getElementById('cookie-banner');
  var cookieAccept = document.getElementById('cookie-accept');
  if (cookieBanner) {
    if (!localStorage.getItem('cmc_cookies_accepted')) {
      setTimeout(function () {
        cookieBanner.classList.add('visible');
      }, 1500);
    }
    cookieAccept && cookieAccept.addEventListener('click', function () {
      localStorage.setItem('cmc_cookies_accepted', '1');
      cookieBanner.classList.remove('visible');
    });
  }
